import { baseApi } from "./baseApi";

const WAREHOUSE_BASE_URL = "/warehouses";

export const warehouseApi = baseApi.injectEndpoints({
  tagTypes: ["Warehouse"],

  endpoints: (build) => ({
    addWarehouse: build.mutation({
      query: (body) => ({
        url: WAREHOUSE_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Warehouse", id: "LIST" }],
    }),
    listWarehouses: build.query({
      query: (params) => ({
        url: WAREHOUSE_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "Warehouse", _id })),
              { type: "Warehouse", id: "LIST" },
            ]
          : [{ type: "Warehouse", id: "LIST" }],
    }),
    getDDLWarehouseList: build.query({
      query: (params) => ({
        url: `${WAREHOUSE_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "Warehouse", id })),
              { type: "Warehouse", id: "DDL" },
            ]
          : [{ type: "Warehouse", id: "DDL" }],
    }),

    getWarehouseDetail: build.query({
      query: (warehouseId) => `${WAREHOUSE_BASE_URL}/${warehouseId}`,
      providesTags: (result, error, { _id }) => [
        { type: "Warehouse", _id },
        { type: "Warehouse", id: "LIST" },
      ],
    }),

    updateWarehouse: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${WAREHOUSE_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "Warehouse", id },
        { type: "Warehouse", id: "LIST" },
      ],
    }),
  }),

  overrideExisting: false,
});

export const {
  useAddWarehouseMutation,
  useListWarehousesQuery,
  useLazyGetDDLWarehouseListQuery,
  useLazyGetDDLWarehouseQuery,
  useLazyListWarehousesQuery,
  useGetWarehouseDetailQuery,
  useUpdateWarehouseMutation,
} = warehouseApi;
